"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingPage;
var _react = _interopRequireDefault(require("react"));
var _Loading = _interopRequireDefault(require("../Loading"));
var _Page = _interopRequireDefault(require("../Page"));
function LoadingPage(_ref) {
  var id = _ref.id;
  return /*#__PURE__*/_react.default.createElement(_Page.default, {
    id: id
  }, /*#__PURE__*/_react.default.createElement(_Loading.default, {
    id: "".concat(id, "Loading")
  }));
}